(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@jcd-web/basic-service"));
	else if(typeof define === 'function' && define.amd)
		define(["@jcd-web/basic-service"], factory);
	else if(typeof exports === 'object')
		exports["basic-storage"] = factory(require("@jcd-web/basic-service"));
	else
		root["basic-storage"] = factory(root["@jcd-web/basic-service"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__jcd_web_basic_service__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/*! exports provided: LocalStorageService, CookieStorageService, StorageService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _storage_LocalStorageService__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./storage/LocalStorageService */ "./src/storage/LocalStorageService.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocalStorageService", function() { return _storage_LocalStorageService__WEBPACK_IMPORTED_MODULE_0__["LocalStorageService"]; });

/* harmony import */ var _storage_CookieStorageService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./storage/CookieStorageService */ "./src/storage/CookieStorageService.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CookieStorageService", function() { return _storage_CookieStorageService__WEBPACK_IMPORTED_MODULE_1__["CookieStorageService"]; });

/* harmony import */ var _storage_StorageService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./storage/StorageService */ "./src/storage/StorageService.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StorageService", function() { return _storage_StorageService__WEBPACK_IMPORTED_MODULE_2__["StorageService"]; });





/***/ }),

/***/ "./src/storage/CookieStorageService.ts":
/*!*********************************************!*\
  !*** ./src/storage/CookieStorageService.ts ***!
  \*********************************************/
/*! exports provided: CookieStorageService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CookieStorageService", function() { return CookieStorageService; });
/* harmony import */ var _jcd_web_basic_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @jcd-web/basic-service */ "@jcd-web/basic-service");
/* harmony import */ var _jcd_web_basic_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_jcd_web_basic_service__WEBPACK_IMPORTED_MODULE_0__);
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

var CookieStorageService = /** @class */function (_super) {
    __extends(CookieStorageService, _super);
    function CookieStorageService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CookieStorageService.initialize = function () {
        this.available = navigator.cookieEnabled;
    };
    CookieStorageService.setCookie = function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };
    CookieStorageService.getCookie = function (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    CookieStorageService.itemExists = function (key) {
        return this.getCookie(key) != "";
    };
    CookieStorageService.getItem = function (key) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.itemExists(key)) {
                resolve(JSON.parse(_this.getCookie(key)));
            } else {
                reject(null);
            }
        });
    };
    CookieStorageService.setItem = function (key, item) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            resolve(_this.setCookie(key, JSON.stringify(item), 365));
        });
    };
    CookieStorageService.removeItem = function (key) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            resolve(_this.setCookie(key, "", 0));
        });
    };
    CookieStorageService.available = false;
    return CookieStorageService;
}(_jcd_web_basic_service__WEBPACK_IMPORTED_MODULE_0__["Service"]);


/***/ }),

/***/ "./src/storage/LocalStorageService.ts":
/*!********************************************!*\
  !*** ./src/storage/LocalStorageService.ts ***!
  \********************************************/
/*! exports provided: LocalStorageService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocalStorageService", function() { return LocalStorageService; });
/* harmony import */ var _jcd_web_basic_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @jcd-web/basic-service */ "@jcd-web/basic-service");
/* harmony import */ var _jcd_web_basic_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_jcd_web_basic_service__WEBPACK_IMPORTED_MODULE_0__);
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

var LocalStorageService = /** @class */function (_super) {
    __extends(LocalStorageService, _super);
    function LocalStorageService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalStorageService.initialize = function () {
        if (typeof localStorage !== 'undefined') {
            try {
                localStorage.setItem('feature_test', 'yes');
                if (localStorage.getItem('feature_test') === 'yes') {
                    localStorage.removeItem('feature_test');
                    this.available = true;
                }
            } catch (e) {}
        }
    };
    LocalStorageService.itemExists = function (key) {
        return localStorage.getItem(key) != null;
    };
    LocalStorageService.getItem = function (key) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.itemExists(key)) {
                resolve(JSON.parse(localStorage.getItem(key)));
            } else {
                reject(null);
            }
        });
    };
    LocalStorageService.setItem = function (key, item) {
        return new Promise(function (resolve, reject) {
            resolve(localStorage.setItem(key, JSON.stringify(item)));
        });
    };
    LocalStorageService.removeItem = function (key) {
        return new Promise(function (resolve, reject) {
            resolve(localStorage.removeItem(key));
        });
    };
    LocalStorageService.available = false;
    return LocalStorageService;
}(_jcd_web_basic_service__WEBPACK_IMPORTED_MODULE_0__["Service"]);


/***/ }),

/***/ "./src/storage/StorageService.ts":
/*!***************************************!*\
  !*** ./src/storage/StorageService.ts ***!
  \***************************************/
/*! exports provided: StorageService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StorageService", function() { return StorageService; });
/* harmony import */ var _jcd_web_basic_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @jcd-web/basic-service */ "@jcd-web/basic-service");
/* harmony import */ var _jcd_web_basic_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_jcd_web_basic_service__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CookieStorageService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CookieStorageService */ "./src/storage/CookieStorageService.ts");
/* harmony import */ var _LocalStorageService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./LocalStorageService */ "./src/storage/LocalStorageService.ts");
var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();



var StorageService = /** @class */function (_super) {
    __extends(StorageService, _super);
    function StorageService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StorageService.initialize = function (useCookies) {
        if (useCookies === void 0) {
            useCookies = false;
        }
        _CookieStorageService__WEBPACK_IMPORTED_MODULE_1__["CookieStorageService"].initialize();
        _LocalStorageService__WEBPACK_IMPORTED_MODULE_2__["LocalStorageService"].initialize();
        if (useCookies) {
            if (_CookieStorageService__WEBPACK_IMPORTED_MODULE_1__["CookieStorageService"].available) {
                this.useCookies = true;
            } else {
                if (_LocalStorageService__WEBPACK_IMPORTED_MODULE_2__["LocalStorageService"].available) {
                    this.useCookies = false;
                }
            }
        } else {
            if (_LocalStorageService__WEBPACK_IMPORTED_MODULE_2__["LocalStorageService"].available) {
                this.useCookies = false;
            } else {
                if (_CookieStorageService__WEBPACK_IMPORTED_MODULE_1__["CookieStorageService"].available) {
                    this.useCookies = true;
                }
            }
        }
        if (this.useCookies === undefined) {
            throw 'No storage system available.';
        }
    };
    StorageService.setItem = function (key, item) {
        if (this.useCookies) {
            return _CookieStorageService__WEBPACK_IMPORTED_MODULE_1__["CookieStorageService"].setItem(key, item);
        } else {
            return _LocalStorageService__WEBPACK_IMPORTED_MODULE_2__["LocalStorageService"].setItem(key, item);
        }
    };
    StorageService.getItem = function (key) {
        if (this.useCookies) {
            return _CookieStorageService__WEBPACK_IMPORTED_MODULE_1__["CookieStorageService"].getItem(key);
        } else {
            return _LocalStorageService__WEBPACK_IMPORTED_MODULE_2__["LocalStorageService"].getItem(key);
        }
    };
    StorageService.removeItem = function (key) {
        if (this.useCookies) {
            return _CookieStorageService__WEBPACK_IMPORTED_MODULE_1__["CookieStorageService"].removeItem(key);
        } else {
            return _LocalStorageService__WEBPACK_IMPORTED_MODULE_2__["LocalStorageService"].removeItem(key);
        }
    };
    return StorageService;
}(_jcd_web_basic_service__WEBPACK_IMPORTED_MODULE_0__["Service"]);


/***/ }),

/***/ "@jcd-web/basic-service":
/*!*****************************************!*\
  !*** external "@jcd-web/basic-service" ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__jcd_web_basic_service__;

/***/ })

/******/ });
});
//# sourceMappingURL=main.js.map